import { useEffect } from "react"
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom"
import "./globals.css"
import { AuthProvider } from "@/contexts/auth-context"
import { Toaster } from "@/components/ui/sonner"
import ReportsHubPage from "@/pages/ReportsHubPage"
import ReportLayout from "@/pages/ReportLayout"
import ReportPage from "@/pages/ReportPage"

function NavigationListener() {
  const navigate = useNavigate()

  useEffect(() => {
    const handleParentMessage = (event: MessageEvent) => {
      try {
        const data = event.data as { action?: string; path?: unknown } | null
        if (!data || typeof data !== "object") return
        if (data.action === "NAVIGATE" && typeof data.path === "string") {
          navigate(data.path, { replace: true })
        }
      } catch (error) {
        console.error("Error handling parent message:", error)
      }
    }

    window.addEventListener("message", handleParentMessage)
    return () => window.removeEventListener("message", handleParentMessage)
  }, [])

  return null
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="light">
          <NavigationListener />
          <Routes>
            <Route path="/" element={<ReportsHubPage />} />
            <Route path="/engagements" element={<ReportLayout />}>
              <Route index element={<Navigate to="/engagements/finance" replace />} />
              <Route path="finance" element={<ReportPage reportCode="engagement-finance" />} />
              <Route path="hours" element={<ReportPage reportCode="engagement-hours" />} />
              <Route path="people" element={<ReportPage reportCode="engagement-people" />} />
              <Route path="time-entries" element={<ReportPage reportCode="engagement-time-entries" />} />
            </Route>
          </Routes>
          <Toaster />
        </div>
      </AuthProvider>
    </BrowserRouter>
  )
}
